module.exports = __webpack_public_path__ + "img/1517348947.1dac0c51.jpg";